/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {PdfHeader} from '../pdf-header';
import {TranslateService} from '@ngx-translate/core';

export abstract class PdfSection {
  public title: string;
  public margin = {w: 12, h: 18};

  protected constructor(title: string) {
    this.title = title;
  }
  public abstract getDimension(doc: any): {w: number, h: number};
  public abstract build(trl: TranslateService, doc: any, header: PdfHeader, x: number, y: number): number;
}
